"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundMusicToJSON = exports.BackgroundMusicFromJSONTyped = exports.BackgroundMusicFromJSON = exports.instanceOfBackgroundMusic = void 0;
var runtime_1 = require("../runtime");
var AssetType_1 = require("./AssetType");
var AudioType_1 = require("./AudioType");
/**
 * Check if a given object implements the BackgroundMusic interface.
 */
function instanceOfBackgroundMusic(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    return isInstance;
}
exports.instanceOfBackgroundMusic = instanceOfBackgroundMusic;
function BackgroundMusicFromJSON(json) {
    return BackgroundMusicFromJSONTyped(json, false);
}
exports.BackgroundMusicFromJSON = BackgroundMusicFromJSON;
function BackgroundMusicFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'assetType': !(0, runtime_1.exists)(json, 'asset_type') ? undefined : (0, AssetType_1.AssetTypeFromJSON)(json['asset_type']),
        'audioType': !(0, runtime_1.exists)(json, 'audio_type') ? undefined : (0, AudioType_1.AudioTypeFromJSON)(json['audio_type']),
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
    };
}
exports.BackgroundMusicFromJSONTyped = BackgroundMusicFromJSONTyped;
function BackgroundMusicToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'asset_type': (0, AssetType_1.AssetTypeToJSON)(value.assetType),
        'audio_type': (0, AudioType_1.AudioTypeToJSON)(value.audioType),
        'name': value.name,
        'url': value.url,
    };
}
exports.BackgroundMusicToJSON = BackgroundMusicToJSON;
